import React from "react";
import NotaryWrapper from "../components/Wrappers/Notary/Wrapper";
import { Helmet } from "react-helmet";

export default function Notaries() {
  return <>
    <Helmet defer={false} >
      <script src="https://www.google.com/recaptcha/api.js" async defer></script>
    </Helmet>
    <NotaryWrapper />
  </>
}